<template>
  <div class="container">
    <hr/>
    <b-row align-h="center">
      <h4>Maintenance en cours</h4>
    </b-row>
    <b-row align-h="center">
      <b-img :src="require('./../assets/maintenance.gif')" fluid style="height: 250px"></b-img>
    </b-row>
    <b-row align-h="center" align-v="center">
      <p>
        Une maintenance d'une durée indéterminée est en cours. Les performances du site peuvent être dégradées.
      </p>
    </b-row>
    <b-row align-h="center" align-v="center">
      <b-button variant="primary" @click="redirectToFilters">Cliquez ici pour accéder au site</b-button>
    </b-row>
  </div>
</template>

<script>

export default {
  name: 'Maintenance',
  methods: {
    redirectToFilters() {
      this.$router.push('/filters');
    }
  }
}
</script>

<style scoped>

</style>